import script from "./ApplicationLogs.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplicationLogs.vue?vue&type=script&setup=true&lang=ts"

import "./ApplicationLogs.vue?vue&type=style&index=0&id=3da239e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3da239e4"]])

export default __exports__